import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { Capacitor } from "@capacitor/core";
import { HelmetProvider } from "react-helmet-async";
import { registerAppSW } from "./pwa/registerSW";

// Register the app's service worker (guarded — skips dev / preview / iframes)
registerAppSW();

// Native platform initialization (StatusBar, Keyboard, Deep Links)
async function initNativePlatform() {
  if (!Capacitor.isNativePlatform()) return;

  try {
    // Status bar — dark background with light content
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    await StatusBar.setStyle({ style: Style.Dark });
    if (Capacitor.getPlatform() === "android") {
      await StatusBar.setBackgroundColor({ color: "#0a0a0a" });
    }
  } catch (err) {
    console.warn("StatusBar init failed:", err);
  }

  try {
    // Deep link / Universal link handler — open in-app instead of browser
    const { App: CapApp } = await import("@capacitor/app");
    CapApp.addListener("appUrlOpen", (event) => {
      // event.url e.g. "https://sportrank.vn/matches/abc-123" or "sportrank://matches/abc-123"
      try {
        const url = new URL(event.url);
        const path = url.pathname + url.search + url.hash;
        if (path && path !== "/") {
          window.history.pushState({}, "", path);
          window.dispatchEvent(new PopStateEvent("popstate"));
        }
      } catch (err) {
        console.warn("Deep link parse failed:", event.url, err);
      }
    });
  } catch (err) {
    console.warn("App deep-link init failed:", err);
  }
}

initNativePlatform();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
